module.exports = __webpack_public_path__ + "media/venue/conferences@2x-58c8092f.png";